/* ============================
 * 会員情報変更フォーム
 * /pages/edit-profile で動作。
 * App Proxy (/apps/roark/customer_app__update_profile) に JSON を Ajax 送信する。
 * パスワードはこのフォームでは扱わない（Shopify標準の再設定メールに任せている）。
 * ============================ */

$(function () {
	var ENDPOINT = '/apps/roark/customer_app__update_profile';
	var SUCCESS_MESSAGE = '会員情報を更新しました';
	var SESSION_REFRESH_MESSAGE =
		'メールアドレスを更新しました。<br>新しいメールアドレスで再度ログインしてください。';
	var PASSWORD_SENDING_MESSAGE = '送信中...';
	var SUCCESS_DISPLAY_MS = 8000;
	var REDIRECT_DELAY_MS = 3500;

	/* ============================
	 * パスワード再設定
	 * フォーム本体は見出し直下、ボタンはページ下部にあり、HTML の form 属性で
	 * 関連付けている。属性だけに頼ると反応しない環境があるため、明示的に送信する。
	 * ============================ */
	$('.js-editProfilePasswordSubmit').on('click', function (event) {
		var recoverForm = $('.js-editProfileRecoverForm').get(0);
		if (!recoverForm) return; // 見つからなければ form 属性の既定動作に任せる
		event.preventDefault();

		// 送信から再読み込みまで無反応に見えるので、押した手応えを出したまま遷移する
		$(this).prop('disabled', true).addClass('is-loading').text(PASSWORD_SENDING_MESSAGE);
		recoverForm.submit();
	});

	var $form = $('.js-editProfileForm');
	if (!$form.length) return;

	var $submit = $form.find('.js-editProfileSubmit');
	// 結果表示は見出し直下にあり、フォームの外側にある
	var $result = $('.js-editProfileResult');

	// 性別は触られたときだけ送る。
	// メタフィールドの初期値が読めていない状態で毎回送ると、
	// 他の項目だけ直した会員の性別まで上書きしてしまうため。
	var genderChanged = false;
	$form.on('change', '.js-editProfileGender', function () {
		genderChanged = true;
	});

	$form.on('submit', function (event) {
		event.preventDefault();
		if ($submit.prop('disabled')) return;

		// フォームには novalidate を付けてあるので、送信前に明示的にブラウザ検証を走らせる
		if (!this.checkValidity()) {
			this.reportValidity();
			return;
		}

		var birthdayError = validateBirthday();
		if (birthdayError) {
			showError(birthdayError);
			return;
		}

		submitForm();
	});

	function submitForm() {
		var initialEmail = $form.data('initial-email');
		var newEmail = $form.find('.js-editProfileEmail').val();
		var emailChanged = Boolean(initialEmail && newEmail && initialEmail !== newEmail);

		$submit.prop('disabled', true).addClass('is-loading');
		$result.stop(true, true).hide();

		$.ajax({
			type: 'POST',
			url: ENDPOINT,
			contentType: 'application/json',
			dataType: 'json',
			data: JSON.stringify(buildPayload())
		})
			.done(function () {
				// メールアドレスを変えると Shopify 側のセッションが切れる。
				// 何が起きたか伝えてからログインページへ送る。
				// 遷移までの間に再送信されないようボタンは disabled のままにする。
				if (emailChanged) {
					showMessage(SESSION_REFRESH_MESSAGE, true);
					setTimeout(function () {
						window.location.href = '/account/login?return_url=/pages/edit-profile';
					}, REDIRECT_DELAY_MS);
					return;
				}

				showMessage(SUCCESS_MESSAGE, false);
				$submit.prop('disabled', false).removeClass('is-loading');
			})
			.fail(function (xhr) {
				showError(parseErrorMessage(xhr));
				$submit.prop('disabled', false).removeClass('is-loading');
			});
	}

	function buildPayload() {
		var customer = {
			last_name: $form.find('.js-editProfileLastName').val(),
			first_name: $form.find('.js-editProfileFirstName').val(),
			email: $form.find('.js-editProfileEmail').val(),
			accepts_marketing: $form.find('.js-editProfileMarketing:checked').val() === 'true'
		};

		if (genderChanged) {
			customer.gender = $form.find('.js-editProfileGender:checked').val() || '指定なし';
		}

		var birthday = readBirthday();
		if (birthday.filled === 3) {
			customer.birthday = { year: birthday.year, month: birthday.month, day: birthday.day };
		} else if (birthday.filled === 0 && $form.data('initial-birthday')) {
			// 元々入っていたものを空にした＝削除の意思表示
			customer.birthday = null;
		}

		return { customer: customer };
	}

	/* ============================
	 * 生年月日
	 * 年・月・日は3つで1つの値。揃っていないものは送らない。
	 * 初期値が読めていない状態で空のまま送っても消えないよう、
	 * 削除は「元々値があって全部消したとき」だけに限る。
	 * ============================ */
	function readBirthday() {
		var year = $.trim($form.find('.js-editProfileBirthYear').val());
		var month = $.trim($form.find('.js-editProfileBirthMonth').val());
		var day = $.trim($form.find('.js-editProfileBirthDay').val());
		var filled = [year, month, day].filter(Boolean).length;

		return { year: year, month: month, day: day, filled: filled };
	}

	// 通常は c_birthday-select.js が付ける required でブラウザが弾く。
	// あちらが読み込めなかったときに、中途半端な入力を黙って捨てないための保険。
	function validateBirthday() {
		var birthday = readBirthday();
		if (birthday.filled === 0 || birthday.filled === 3) return null;
		return '生年月日は年・月・日をすべて選択してください。';
	}

	/* ============================
	 * メッセージ表示
	 * ============================ */
	function showMessage(html, keepVisible) {
		$result
			.removeClass('is-error')
			.addClass('is-success')
			.html(html)
			.prop('hidden', false)
			.show();

		scrollToTop();

		if (!keepVisible) {
			$result.delay(SUCCESS_DISPLAY_MS).fadeOut(300);
		}
	}

	function showError(message) {
		$result
			.removeClass('is-success')
			.addClass('is-error')
			.text(message)
			.prop('hidden', false)
			.show();

		scrollToTop();
	}

	// メッセージは見出し直下にあるので、成否にかかわらずページ先頭まで戻す
	function scrollToTop() {
		$('html, body').animate({ scrollTop: 0 }, 300);
	}

	/* ============================
	 * エラー整形
	 * サーバは { result: "文言" } か { result: { field: ["文言"] } } を返す
	 * ============================ */
	function parseErrorMessage(xhr) {
		var fallback = '更新に失敗しました。時間をおいて再度お試しください。';
		var body;

		try {
			body = JSON.parse(xhr.responseText);
		} catch (error) {
			return fallback;
		}

		if (!body || !body.result) return fallback;
		if (typeof body.result === 'string') return body.result;

		var lines = [];
		Object.keys(body.result).forEach(function (field) {
			var messages = body.result[field];
			lines.push(field + ': ' + (Array.isArray(messages) ? messages.join(', ') : messages));
		});
		return lines.length ? lines.join(' / ') : fallback;
	}
});
